export { useDetachResponsibleFromLead } from './useDetachResponsibleFromLead';
